export default __webpack_public_path__ + "static/media/dr-sophie-front-desk.23d43fa7.jpg";